import axios from "axios";

/* const token = localStorage.getItem("authToken"); */
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    accept: "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userid");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);


export default api;